<template>
  <div class="account_sell" v-loading.fullscreen.lock="uploadLoading"
       element-loading-text="文件上传中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="list">
      <div class="steps">
        <el-steps align-center :active="active">
          <el-step title="选择估价游戏"></el-step>
          <el-step title="填写账号信息"></el-step>
          <el-step title="提交估价信息"></el-step>
        </el-steps>
      </div>
      <div class="content1" v-if="active===0">
        <div class="content1_body">
          <div class="tree">
            <div class="treeBtn" :class="treeBtnSelect == item.id ? 'treeBtnSelect':''" v-for="(item,index) in treeList"
                 @click="getGameList(item.id)"
                 :key="index">
              <span></span>
              {{ item.name }}
            </div>
          </div>
          <div class="content1_content">
            <div class="game_list_panel">
              <div class="game_loading" v-if="gameListLoading">
                <i class="el-icon-loading"></i>
              </div>
              <div class="C1C_cardList" ref="nav" v-if="c1GameList.length > 0">
                <div class="game_list" v-for="(item, index) in c1GameList" :key="index" :title="item.label" @click="c1Next(item)">
                  <img :src="item.game_image" :alt="item.label">
                  <span class="game_name" :title="item.label">{{ item.label }}</span>
                </div>
              </div>
              <div class="empty_game" v-else-if="!gameListLoading">
                <div class="empty_icon">
                  <i class="el-icon-box"></i>
                </div>
                <div class="empty_title">暂无可估价游戏</div>
                <div class="empty_text">请切换游戏分类或稍后再试</div>
              </div>
            </div>
            <div class="c1_tip" v-if="c1GameList.length > 0"><img src="@/assets/image/AccountValuation/c1_tip.png" alt="">选择游戏后自动跳转填写账号信息</div>
          </div>
        </div>
      </div>
      <div class="content2" v-if="active===1">
        <el-form :model="infoForm" :rules="rules" ref="infoForm" :label-width="gameItem.value=== 50?'240px':'220px'" class="demo-ruleForm">
          <div class="c2CurrentSelection">
            <div class="c2Title"><img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
              <div>当前选择的游戏为</div>
            </div>
            <div class="c2SelectedContent">
                <img :src="gameItem.game_image" alt="选择游戏">{{gameItem.label}}
                <div class="resBtn" @click="resBtn">重选</div>
            </div>
          </div>
          <template v-if="gameItem.value!=8 && gameItem.value!=49">
            <div class="c2ProductInfo">
              <div class="c2Title">
                <img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                <div>基本信息</div>
                <div class="tip" v-if="gameItem.value === 26 || gameItem.value === 161">
                  估价以角色、武器勾选为准，请认真勾选角色、武器。（图片只辅助估价）
                  <img src="@/assets/image/AccountValuation/YS_tip.png" alt="">
                </div>
              </div>
              <el-form-item :label="item.cat_name" :prop="item.unique_id" v-for="item in filterData" :key="item.cat_id">
                <el-select
                  :disabled="item.unique_id=='yxlx'&&infoForm['ayx']==52&&gameItem.value === 161"
                  :popper-append-to-body="false"
                  v-model="infoForm[item.unique_id]"
                  :placeholder="'请选择'+item.cat_name.slice(1)"
                  @input="store_cache"
                  @change="inChilds(item,infoForm[item.unique_id],isStorage)">
                  <el-option :label="items.name" :value="items.id" v-for="(items) in item.entries" :key="items.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="英雄数量" prop="hero_num" v-if="gameItem.value === 12">
                <el-input-number :controls="false" v-model="infoForm.hero_num" placeholder="请输入英雄数量" :precision="0" :step="1" @input="store_cache"></el-input-number>
              </el-form-item>
              <el-form-item label="皮肤数量" prop="skin_num" v-if="gameItem.value === 12 || gameItem.value === 13">
                <el-input-number :controls="false" v-model="infoForm.skin_num" placeholder="请输入皮肤数量" @input="store_cache" :precision="0" :step="1" :min="0" :max="gameItem.value === 13 || 12?999:null"></el-input-number>
              </el-form-item>
<!--              <el-form-item label="王者营地ID" prop="king_camp_id" v-if="gameItem.value === 13">-->
<!--                <el-input-number :controls="false" v-model="infoForm.king_camp_id" placeholder="请输入营地ID" @input="store_cache"></el-input-number>-->
<!--                &lt;!&ndash; <el-input v-model.number="infoForm.king_camp_id" placeholder="输入营地ID" @input="store_cache"></el-input> &ndash;&gt;-->
<!--                <a href="#" class="how_king" @click="camp_accountTipShow = true"><i class="el-icon-question"></i>如何查询营地账号</a>-->
<!--              </el-form-item>-->
              <el-form-item label="贵族等级" prop="nobility_level" v-if="gameItem.value === 13">
                <el-input-number :controls="false" v-model="infoForm.nobility_level" placeholder="请输入贵族等级" :precision="0"  :step="1" @input="store_cache" :min="0" :max="10"></el-input-number>
                <!-- <el-input v-model.number="infoForm.nobility_level" placeholder="请输入贵族等级" @input="store_cache"></el-input> -->
              </el-form-item>
              <el-form-item label="背包剩余荣耀水晶数量"  v-if="gameItem.value === 13">
                <el-input-number :controls="false" v-model="infoForm.honor_crystal" placeholder="请输入荣耀水晶数量" @input="store_cache" :precision="0" :step="1"  :min="0" :max="999"></el-input-number>
              </el-form-item>
              <el-form-item label="大国标数"  v-if="gameItem.value === 13">
                <el-input-number :controls="false" v-model="infoForm.big_nation" placeholder="请输入大国标数量" @input="store_cache" :precision="0"  :step="1" :min="0" :max="999"></el-input-number>
              </el-form-item>
              <el-form-item label="小国标数"  v-if="gameItem.value === 13">
                <el-input-number :controls="false" v-model="infoForm.small_nation" placeholder="请输入小国标数量" @input="store_cache" :precision="0"  :step="1"  :min="0" :max="999"></el-input-number>
              </el-form-item>
              <el-form-item label="和平营地ID" prop="king_camp_id" v-if="gameItem.value === 11">
                <el-input-number :controls="false" v-model="infoForm.king_camp_id" placeholder="请输入营地ID" @input="store_cache"></el-input-number>
                <!-- <el-input v-model="infoForm.king_camp_id" placeholder="请输入营地ID" @input="store_cache"></el-input> -->
                <!-- <a href="#" class="how_king" @click="camp_accountTipShow = true"><i class="el-icon-question"></i>如何查询营地账号</a> -->
              </el-form-item>
              <el-form-item label="助手社区ID：（数字）" prop="camp_account" v-if="gameItem.value === 25">
                <el-input-number :controls="false" v-model="infoForm.camp_account" placeholder="请输入助手社区ID" @input="store_cache"></el-input-number>
                <!-- <el-input v-model="infoForm.king_camp_id" placeholder="请输入营地ID" @input="store_cache"></el-input> -->
                <!-- <a href="#" class="how_king" @click="camp_accountTipShow = true"><i class="el-icon-question"></i>如何查询营地账号</a> -->
              </el-form-item>
              <el-form-item label="剩余R点"  v-if="gameItem.value === 130 || gameItem.value == 148">
                <el-input-number :controls="false" v-model="infoForm.skin_num" placeholder="请输入剩余R点数量" @input="store_cache" :precision="0"  :step="1"></el-input-number>
              </el-form-item>
              <el-form-item label="剩余VP"  v-if="gameItem.value === 130 || gameItem.value == 148">
                <el-input-number :controls="false" v-model="infoForm.hero_num" placeholder="请输入剩余VP数量" @input="store_cache" :precision="0"  :step="1" ></el-input-number>
              </el-form-item>
              <div v-for="(item) in filterOptions" :key="item.id">
                <el-form-item :label="item.cat_name" v-if="(gameItem.value === 26 && item.cat_id !== 2 && item.cat_id !== 3) || gameItem.value !== 26">
                  <el-select
                    :popper-append-to-body="false"
                    v-model="infoForm[item.cat_id]"
                    filterable
                    multiple collapse-tags placeholder="请输入搜索关键字"
                    @input="store_cache">
                    <el-option
                      v-for="items in item.entries"
                      :key="items.id"
                      :label="items.name" :value="items.id">
                    </el-option>
                  </el-select>
                  <span class="curr_choose" v-if="getTipsInfo(infoForm[item.cat_id],item.entries)">当前选择：<i v-html="getTipsInfo(infoForm[item.cat_id],item.entries)"></i></span>
                </el-form-item>
              </div>
              <!-- <el-form-item label="上传图片" prop="cdata" v-if="gameItem.value === 8">
                <el-upload
                  action="#"
                  list-type="picture-card"
                  multiple
                  :on-change="(e)=>{
                    addChange(e,'cdata')
                  }"
                  :file-list="fileList"
                  :auto-upload="false">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.file_path" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span class="el-upload-list__item-delete" @click="handleRemove(file,'cdata')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" top="10vh">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
              </el-form-item> -->

              <el-form-item label="角色图鉴" prop="cdata" v-if="gameItem.value === 26 || gameItem.value === 8 || gameItem.value === 161">
                <span slot="label" >{{gameItem.value === 26?'角色图鉴':'上传图片'}}</span>
                <ul class="el-upload-list el-upload-list--picture-card">
                  <draggable v-model="fileList" style="display: flex;flex-direction: row;flex-wrap: wrap">
                    <div v-for="(item, index) in fileList" :key="index" class="el-upload-list__item is-success animated">
                      <img :src="item.file_path" alt="" class="el-upload-list__item-thumbnail">
                      <i class="el-icon-close"></i>
                      <span class="el-upload-list__item-actions">
                          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(item)">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span class="el-upload-list__item-delete" @click="handleRemove(item,'cdata')">
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                    </div>
                    <div>
                      <el-upload
                        action="#"
                        list-type="picture-card"
                        multiple
                        ref="uploadcdata"
                        :on-change="(e,el)=>{
              addChange(e,el,'cdata')
            }"
                        :show-file-list="false"
                        :file-list="fileList"
                        :auto-upload="false">
                        <i slot="default" class="el-icon-plus"></i>
                      </el-upload>
                      <a href="#" class="how_king" @click="ys_accountTipShow = true"><i class="el-icon-question"></i>如何获取全部角色图标</a>
                    </div>
                  </draggable>
                  <el-dialog :visible.sync="dialogVisible" top="10vh">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </ul>
              </el-form-item>
              <el-form-item label="武器图鉴" prop="armsData" v-if="gameItem.value === 26 || gameItem.value === 161">
                <ul class="el-upload-list el-upload-list--picture-card">
                  <draggable v-model="fileListA" style="display: flex;flex-direction: row;flex-wrap: wrap">
                    <div v-for="(item, index) in fileListA" :key="index" class="el-upload-list__item is-success animated">
                      <img :src="item.file_path" alt="" class="el-upload-list__item-thumbnail ">
                      <i class="el-icon-close"></i>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(item)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click="handleRemove(item,'armsData')">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                    <el-upload
                      action="#"
                      list-type="picture-card"
                      multiple
                      ref="uploadarmsData"
                      :on-change="(e,el)=>{
              addChange(e,el,'armsData')
            }"
                      :show-file-list="false"
                      :file-list="fileListA"
                      :auto-upload="false">
                      <i slot="default" class="el-icon-plus"></i>
                      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                  </draggable>
                  <el-dialog :visible.sync="dialogVisible" top="10vh">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </ul>
              </el-form-item>
              <el-form-item label="热门金色皮肤+传家宝+通行证截图" prop="armsData" v-if="gameItem.value === 50">
                <ul class="el-upload-list el-upload-list--picture-card">
                  <draggable v-model="fileListA" style="display: flex;flex-direction: row;flex-wrap: wrap">
                    <div v-for="(item, index) in fileListA" :key="index" class="el-upload-list__item is-success animated">
                      <img :src="item.file_path" alt="" class="el-upload-list__item-thumbnail ">
                      <i class="el-icon-close"></i>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(item)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click="handleRemove(item,'armsData')">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                    <el-upload
                      action="#"
                      list-type="picture-card"
                      multiple
                      ref="uploadarmsData"
                      :on-change="(e,el)=>{addChange(e,el,'armsData')}"
                      :show-file-list="false"
                      :file-list="fileListA"
                      :auto-upload="false">
                      <i slot="default" class="el-icon-plus"></i>
                      <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                  </draggable>
                  <el-dialog :visible.sync="dialogVisible" top="10vh">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </ul>
              </el-form-item>
              <div class="melee_weapon" v-for="(item) in filterGrouping" :key="item.id">
                <div class="mw_title">{{item.cat_name}}（选填）</div>
                <el-form-item
                  label-width="120px"
                  :label="items.cat_name"
                  v-for="items in item.entries"
                  :key="items.cat_id">
                  <el-select
                    :popper-append-to-body="false"
                    v-model="infoForm[items.cat_id]"
                    multiple collapse-tags placeholder="请输入搜索关键字"
                    filterable
                    @input="store_cache"
                    @change="inChilds(items,infoForm[items.cat_id])">
                    <el-option
                      v-for="itemss in items.entries"
                      :key="itemss.id"
                      :label="itemss.name" :value="itemss.id">
                    </el-option>
                  </el-select>
                  <span class="curr_choose" v-if="getTipsInfo(infoForm[items.cat_id],items.entries)">当前选择：<i v-html="getTipsInfo(infoForm[items.cat_id],items.entries)"></i></span>
                </el-form-item>
              </div>

              <tab-card  v-if="gameItem.value === 26 || gameItem.value === 161" :options-list="roleList" style="margin-bottom: 30px" @change="roleChange"></tab-card>
              <weapon-tab-card :gameId="gameItem.value"  v-if="gameItem.value === 26 || gameItem.value === 161" :options-list="weaponList" @change="armsChange"></weapon-tab-card>
            </div>
            <div class="c2ProductInfo">
              <div class="c2Title"><img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                <div>联系方式</div>
              </div>
              <el-form-item label="QQ号" prop="qq">
                <el-input v-model="infoForm.qq" placeholder="请输入QQ号" @input="store_cache"></el-input>
              </el-form-item>
              <el-form-item label="微信号" prop="wx">
                <el-input v-model="infoForm.wx" placeholder="请输入微信号" @input="store_cache"></el-input>
              </el-form-item>
            </div>
            <div class="c2RemarkConnect">
              <div class="c2Title"><img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                <div>备注说明</div>
              </div>
              <el-form-item label="备注说明">
                <el-input
                  type="textarea"
                  class="remark_st"
                  placeholder="如账号估价有特殊需求，请输入......"
                  @input="store_cache"
                  v-model="infoForm.remark">
                </el-input>
              </el-form-item>
            </div>
          </template>
          <template v-else>
            <div class="c2ProductInfo tymyd_fuck">
              <div class="c2Title"><img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                <div>注意事项</div>
              </div>
              <div class="fuck_tymyd_tip">该游戏因为养成内容极多，少任意一张截图可能都会导致估价严重失准，因此需要您先任意价格提交上架之后，24小时内我们的估价专员会给与您反馈具体建议价格！</div>
              <div class="fuck_tymyd_btn" @click="fuck_tymyd_btn">估价并上架</div>
            </div>
          </template>
        </el-form>
        <div class="c2SubmitBtn" v-if="gameItem.value!=8 && gameItem.value!=49">
          <div id="c2SubmitBtn" @click="c2Next('infoForm')">立即发布</div>
        </div>
      </div>
      <div class="content3" v-if="active===2">
        <div class="c3Img">
          <img src="@/assets/image/AccountDeal/sellSuccess.png" alt="">
          <div class="c3Img_text">
            <div class="c3_success">恭喜您估价信息提交成功！</div>
            <div class="c3_ground">
              <div class="c3G_id">预计<span>24小时内</span>出结果</div>
              <div class="c3G_text">请留心消息中心系统通知～</div>
            </div>
          </div>
        </div>
        <div class="c3_tip">(上架问题请联系在线客服)</div>
        <a class="c3Btn c3CusSerBtn" @click="cusSerBtnClicks" href="#">
          联系客服
        </a>
        <!-- <a v-else class="c3Btn c3CusSerBtn" @click="$accessLink(sell_customer)"
          :href="`${sell_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`" target="_blank">
          联系客服
        </a> -->
        <router-link :to="{name:'Home'}" class="c3Btn">返回首页</router-link>
      </div>
    </div>
    <!-- 选择游戏缓存弹窗 -->
    <el-dialog
      :visible.sync="UnpublishedDialogVisible"
      custom-class="Unpublished"
      :show-close="false"
      width="414px"
      top="35vh"
      center>
          <span>
            <div id="UPS_main">
              <div class="UPS_info">
                <div class="UPS_name">{{gameItem.label}}存在未发布数据</div>
                <div class="UPS_text">是否继续填写上次编辑的内容</div>
              </div>
              <div class="UPS_btn">
                <button class="UPS_reset" @click="resetnt(1)" target="_blank">重新编辑</button>
                <button class="UPS_continue" @click="resetnt(2)" target="_blank">继续填写</button>
              </div>
            </div>
            <img class="UPS_close" src="@/assets/image/AccountDeal/close.png" alt="" @click="UnpublishedDialogVisible = false">
          </span>
    </el-dialog>
    <!-- 王者营地提示弹窗 -->
    <el-dialog
      :visible.sync="camp_accountTipShow"
      custom-class="camp_accountDialog"
      top="10vh"
      :show-close="false"
      center
    >
      <div id="camp_accountDialog">
        <img class="content" src="https://images.pxb7.com/images/upload/image/20220303/1646289484638343.png" alt="">
        <img class="btn" @click="camp_accountTipShow = false" src="@/assets/image/AccountDeal/tipClose.png" alt="">

      </div>
    </el-dialog>
    <!-- 原神角色图鉴提示框 -->
    <el-dialog
      :visible.sync="ys_accountTipShow"
      custom-class="camp_accountDialog"
      top="10vh"
      :show-close="false"
      center
    >
      <div id="ys_accountDialog">
        <img class="content" :src="gameItem.value==161?'https://images.pxb7.com/images/images/upload/image/20230510/20230510183013_47974.png':'https://images.pxb7.com/images/upload/image/20220324/1648085455670824.png'" alt="">
        <img class="btn" @click="ys_accountTipShow = false" src="@/assets/image/AccountDeal/tipClose1.png" alt="">

      </div>
    </el-dialog>
    <!-- 步骤2提交弹窗 -->
    <el-dialog
      :visible.sync="EstimateSubmission"
      custom-class="Unpublished"
      :show-close="false"
      width="414px"
      top="35vh"
      center>
          <span>
            <div id="UPS_main">
              <div class="UPS_info">
                <div class="UPS_name">是否确认提交估价</div>
              </div>
              <div class="UPS_btn">
                <button class="UPS_continue ESconfirm" @click="ESsubmit" target="_blank">确认</button>
              </div>
            </div>
            <img class="UPS_close" src="@/assets/image/AccountDeal/close.png" alt="" @click="EstimateSubmission = false">
          </span>
    </el-dialog>
<!--    估价信息提交的弹窗-->
    <el-dialog
      :visible.sync="valuationDialog"
      custom-class="Unpublished"
      :show-close="false"
      width="498px"
      top="35vh"
      center>
      <span>
            <div id="UPS_main">
              <div class="UPS_info">
                <div class="UPS_name">您的估价信息已提交，可在站内信中查看估价结果</div>
              </div>
              <div class="UPS_btn">
                <button class="UPS_reset" @click="continueValuation" target="_blank">继续估价</button>
                <button class="UPS_continue" @click="seeValuation" target="_blank">查看</button>
              </div>
            </div>
            <img class="UPS_close" src="@/assets/image/AccountDeal/close.png" alt="" @click="valuationDialog = false">
          </span>

    </el-dialog>
    <!-- <div class="advertising" v-if="active===1">
      <img v-if="gameItem.value === 12" src="../../assets/image/AccountValuation/advertising12.png" alt="">
      <img v-else-if="gameItem.value === 13" src="../../assets/image/AccountValuation/advertising13.png" alt="">
      <img v-else-if="gameItem.value === 26" src="../../assets/image/AccountValuation/advertising26.png" alt="">
    </div> -->
  </div>
</template>
<script>
import {
  apiGameListForValuation,
  apiProductCategory,
  apiValuation,
  apiValuationDetail,
  apiProductPcate,
  apiUploadPicture
} from '@/request/API'
import storage from '@/util/storage'
import * as imageConversion from "image-conversion";
import tabCard from "@/views/AccountValuation/components/tabCard";
import weaponTabCard from "@/views/AccountValuation/components/weaponTabCard";
import breadcrumb from "@/components/breadcrumb";

import draggable from 'vuedraggable'

/**
 * 表单验证失败时 滚动到第一个error位置
 */
const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};
export default {
  name: '',
  props: {},
  components:{
    breadcrumb,
    draggable,
    tabCard,
    weaponTabCard
  },
  data() {
    return {
      breadcrumbList: [
        {name: '账号估价'}
      ],
      valuationInfo: {},
      valuationDialog:false,
      //c1 test
      //左侧树
      treeList: [
        {name: '全部游戏', id: ''},
        {name: '网络游戏', id: 1},
        {name: '手机游戏', id: 2},
      ],
      //左侧树 选中项
      treeBtnSelect: '',

      // 未发布数据弹窗
      UnpublishedDialogVisible: false,
      // 提交估价确认
      EstimateSubmission: false,
      //c1
      active: 0,
      gameListLoading: false,
      gameListRequestId: 0,
      gameListLoadingTimer: null,
      c1GameList: [],
      c1Form: {},

      //c2
      gameItem: {},
      filterData: [],
      filterOptions: [],
      filterGrouping: [],
      formKeyList: {},

      dialogImageUrl:'',
      dialogVisible: false,
      fileList: [],
      fileListA: [],
      filePath: [],
      filePathA: [],
      //王者荣耀 营地账号提示
      camp_accountTipShow: false,
      // 原神 角色图鉴提示
      ys_accountTipShow: false,
      uploadLoading:false,

      //游戏账号表单校验规则
      rules: {
        skin_num: [
          {required: true, message: '请输入拥有皮肤数量', trigger: 'blur'}
        ],
        hero_num: [
          {required: true, message: '请输入拥有英雄数量', trigger: 'blur'}
        ],
        qq: [
          {required: true, message: '请输入QQ号', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{4,9}$/, message: 'QQ账号格式错误'}
        ],
        wx: [
          {required: true, message: '请输入微信号', trigger: 'blur'}
        ],
        // qq: [
        //   {required: false, validator: this.validatePass, trigger: 'blur'}
        // ],
        // wx: [
        //   {required: false, validator: this.validatePass1, trigger: 'blur'}
        // ],
        //
        king_camp_id: [
          {required: true, message: '请输入营地账号', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{6,11}$/, message: '营地账号格式错误'}
        ],
        camp_account: [
          {required: true, message: '请输入助手社区ID', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{4,11}$/, message: '助手社区ID格式错误'}
        ],

        cdata: [
          {required: true, validator: this.validatecdata, trigger: 'change'}
        ],
        armsData: [
          {required: true, validator: this.validatearmsData, trigger: 'change'}
        ],
        nobility_level: [
          {required: true, message: '请输入贵族等级', trigger: 'blur'}
        ],
      },

      //游戏账号表单
      infoForm: {
        cdata:[],
        armsData:[],
        skin_num: undefined,//皮肤数量
        honor_crystal:undefined,//荣耀水晶数量
        big_nation:undefined,//大国标数量
        small_nation:undefined,//小国标数量
        hero_num: undefined,
        king_camp_id: undefined,
        nobility_level: undefined,
        qq:'',
        wx:'',
        remark:'',
        camp_account:''
      },
      // 客服
      sell_customer: '',
      // 是否是缓存数据
      isStorage:false,
      //原神角色列表
      roleList:[],
      role:[],
      //原神武器列表
      weaponList:[],
      arms:[],
      addFlag:true,
      gameId:26

    }
  },
  methods: {
    /**
     * @description: 天涯明月刀估价
     * @return {*}
     */
    fuck_tymyd_btn() {
      this.$router.push({
        name: 'AccountSell',
        query: {
          game_id: this.gameItem.value,
          type: 'valuation'
        }
      })
    },
    //继续估价
    continueValuation(){
      apiValuationDetail({
        id: this.valuationInfo.id
      }).then(res => {
        const {id, assess_price, assess_price_note} = res.data
        this.$sensorsTrack.ContinueValuationClick(
          id,
          this.gameItem.label,
          this.gameItem.value,
          assess_price * 1,
          assess_price_note,
          '',
          '',
        )
      })
      this.active = 1;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      // this.$data.infoForm = this.$options.data().infoForm

      this.infoForm={
        cdata:[],
        armsData:[],
        skin_num: undefined,
        hero_num: undefined,
        king_camp_id: undefined,
        nobility_level: undefined,
        qq:'',
        wx:'',
        remark:'',
        camp_account:''}
      this.fileList=[]
      this.fileListA=[]
      this.filePath=[]
      this.filePathA=[]
      this.getProductCategory(this.gameItem.value)
      this.$nextTick(()=>{
        this.$refs['infoForm'].clearValidate();

      })

      this.valuationDialog=false
    },
    //站内信中查看估价结果
    seeValuation(){
      this.valuationDialog=false

      this.$router.push({
        path:"/personalCenter/siteNotice",
      })
    },
    cusSerBtnClicks() {
      this.$openIM({
        game_id: this.gameItem.value,
        gameAlias: this.gameItem.game_alias,
      })
    },
    // 查看上传的图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.file_path;
      this.dialogVisible = true;
    },
    // 删除上传的图片
    handleRemove(file, key) {
      this.infoForm[key].splice(this.infoForm[key].findIndex(item => item == file.file_path),1)
      if(key=='cdata'){
        this.fileList.splice(this.fileList.findIndex(item => item.uid === file.uid), 1)
        this.filePath.splice(this.filePath.findIndex(item => item.uid === file.uid), 1)
      }else{
        this.fileListA.splice(this.fileListA.findIndex(item => item.uid === file.uid), 1)
        this.filePathA.splice(this.filePathA.findIndex(item => item.uid === file.uid), 1)
      }
      this.store_cache()
    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
    uuid() {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      let uuid = s.join("");
      return uuid;
    },
    /**
     * 图片上传
     * @params key 图片上传字段名称
    */
    async addChange(file,fileList,key) {
      if(key=='cdata'){
        this.fileList = fileList
      }else{
        this.fileListA = fileList
      }
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        this.$refs['upload'+key].uploadFiles = this.$refs['upload'+key].uploadFiles.filter(val => val.uid !== file.uid)
        return
      }
      this.uploadLoading = true

      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 1024,
        type: 'image/jpeg'
      })
      file.raw = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})

      let data = new FormData()
      data.append('file', file.raw)
      const res=await apiUploadPicture(data).catch(err=>{
        this.$refs['upload'+key].uploadFiles = this.$refs['upload'+key].uploadFiles.filter(val => val.uid !== file.uid)
        this.$message({
          type: "error",
          center: true,
          message: err.msg + '(5M以内的png或jpg格式的图片)'
        })
      }).finally(()=>{
        this.uploadLoading = false

      })
      let obj = new Object()
      obj.path = res.data.file_path
      obj.uid = file.uid
      file.file_path = res.data.file_path
      if(!this.infoForm.hasOwnProperty(key)){
        this.infoForm[key]=[]
      }
      this.infoForm[key].push(obj.path)

      if(key=='cdata'){
        this.$set(this.fileList,fileList.findIndex(item => item === file),file)
        this.$set(this.filePath,fileList.findIndex(item => item === file),data)
        this.$refs.infoForm.validateField('cdata');
      }else{
        this.$set(this.fileListA,fileList.findIndex(item => item === file),file)
        this.$set(this.filePathA,fileList.findIndex(item => item === file),data)
        this.$refs.infoForm.validateField('armsData');
      }
      this.store_cache()

    },
    /**
     * 多选框显示当前选择内容
     */
    getTipsInfo(key,list){
      let info = [];
      if(list&&key){
        list.map(item=>{
          if(key.indexOf(item.id)!=-1){
            info.push(item.name)
          }
        })
      }
      return info.join(' / ')
    },
    /**
     *获取是否缓存
     * */
    resetnt(n){
      if(n===1){
        storage.removeItem(this.gameItem.game_alias+this.gameItem.value)
        this.fileList = []
        this.fileListA = []
        this.filePath = []
        this.filePathA = []
        this.roleList = []
        this.role = []
        this.weaponList = []
        this.arms = []
        this.UnpublishedDialogVisible = false;
      } else {
        let storageinfo = storage.getItem(this.gameItem.game_alias+this.gameItem.value)
        this.UnpublishedDialogVisible = false
        this.infoForm = storageinfo.infoForm || {};
        this.fileList = storageinfo.fileList ||[];
        this.fileListA = storageinfo.fileListA||[];
        this.filePath = storageinfo.filePath || [];
        this.filePathA = storageinfo.filePathA || [];
        this.isStorage = false
        if(this.infoForm.childList){
          let childList = this.infoForm.childList;
          for(let i in this.infoForm){
            if(childList.indexOf(i)!=-1){
              this.inChilds({unique_id:i,haveChild:true}, this.infoForm[i],this.isStorage)
            }
          }
        }

      }
      this.active = 1;
      this.$nextTick(()=>{
        this.$refs['infoForm'].clearValidate();
        if(n===1){
          this.$refs.infoForm.resetFields();
        }
      })
    },
    // haveChild数据


    inChilds(item, items,isSt){
      if(item.unique_id=='ayx'&&this.gameItem.value === 161){
        if(this.infoForm['ayx']==52){
          this.$set(this.rules, 'yxlx', [{required: false, message: '请选择'+item.cat_name.slice(1), trigger: 'change'}])
        } else{
          this.$set(this.rules, 'yxlx', [{required: true, message: '请选择'+item.cat_name.slice(1), trigger: 'change'}])
        }
      }
      if(item.haveChild){
        if(this.infoForm.childList){
          if(this.infoForm.childList.indexOf(item.unique_id)==-1){
            this.infoForm.childList.push(item.unique_id)
          }
        }else{
          this.infoForm.childList = [item.unique_id]
        }
        apiProductPcate({
          game_id: this.gameItem.value,
          pid: items
        }).then(res => {
          for (let resKey in res.data.list) {
            this.filterData.forEach((Ditems, Dindexs) => {
              if (Ditems.cat_id === parseInt(resKey)) {
                  Ditems.entries=[]
                  res.data.list[resKey].forEach((keyItem, keyIndex) => {
                  Ditems.entries.push(keyItem)
                })
              }
            })
          }

          if(this.isStorage){
            for(let i in this.formKeyList){
              if(this.formKeyList[i]==res.data.pcat_id){
                let val  = this.infoForm[i]?'':this.infoForm[i]
                this.$set(this.infoForm,i,val)
              }
            }
          }
          this.isStorage = true
        })
      }
      this.$forceUpdate();
    },
    // 将估号数据存入缓存
    store_cache(){
      let newForm = {}
      let infoForm = this.infoForm || {};
      for(let i in  infoForm){
        if(infoForm[i]){
          if(typeof infoForm[i]!='number'){
            if(infoForm[i].length>0){
              newForm.infoForm = newForm.infoForm || {};
              newForm.infoForm[i] = infoForm[i]
            }
          }else{
            newForm.infoForm = newForm.infoForm || {};
          newForm.infoForm[i] = infoForm[i]
          }
        }
      }
      let fileList = this.fileList || [];
      if(fileList.length>0){
        newForm.fileList = this.fileList
      }
      let fileListA = this.fileListA || [];
      if(fileListA.length>0){
        newForm.fileListA = this.fileListA
      }
      let filePath = this.filePath || [];
      if(filePath.length>0){
        newForm.filePath = this.filePath
      }
      let filePathA = this.filePathA || [];
      if(filePathA.length>0){
        newForm.filePathA = this.filePathA
      }
      if(Object.keys(newForm).length>0)
      storage.setItem(this.gameItem.game_alias+this.gameItem.value,newForm)
    },
    /**
     * 获取游戏列表
     */
    getGameList(type) {
      const requestId = this.gameListRequestId + 1
      const loadingStartTime = Date.now()
      const minLoadingTime = 300

      this.gameListRequestId = requestId
      this.treeBtnSelect = type
      this.gameListLoading = true
      clearTimeout(this.gameListLoadingTimer)
      apiGameListForValuation({
        class_id: type,
      }).then(res => {
        this.c1GameList = []
        res.data.forEach((item, index) => {
          if(item.assess_on == 1){
            let option = new Object()
            option.value = item.game_id
            option.label = item.game_name
            option.game_alias = item.game_alias
            option.game_image = item.game_image
            option.sys_service_type = item.sys_service_type
            this.c1GameList.push(option)
          }
        })
      }).finally(() => {
        const closeLoading = () => {
          if (this.gameListRequestId === requestId) {
            this.gameListLoading = false
          }
        }
        const remainTime = minLoadingTime - (Date.now() - loadingStartTime)
        if (remainTime > 0) {
          this.gameListLoadingTimer = setTimeout(closeLoading, remainTime)
        } else {
          closeLoading()
        }
      })
    },
    // 图片校验
    validatearmsData  (rule, value, callback) {
      this.filePathA = this.filePathA || []
      let val = value || []
      if (val.length == 0 &&this.filePathA.length == 0) {
        callback(new Error('请上传图片'));
      } else {
        callback();
      }

    },
    validatecdata  (rule, value, callback) {
      this.filePath = this.filePath || []
      let val = value || []
      if (val.length == 0 &&this.filePath.length == 0) {
        callback(new Error('请上传图片'));
      } else {

        callback();
      }

    },
    /**
     * 获取 游戏账号 筛选表单数据
     * @param game_id  游戏id
     */
    getProductCategory(game_id) {
      this.filterData = []
      this.filterOptions = []
      this.filterGrouping = []
      this.filePath = []
      this.filePathA = []
      this.fileList = []
      this.fileListA = []
      this.role = []
      this.arms = []
      this.infoForm = {
        cdata:[],
        armsData:[],
        skin_num: undefined,//皮肤数量
        honor_crystal:undefined,//荣耀水晶数量
        big_nation:undefined,//大国标数量
        small_nation:undefined,//小国标数量
        hero_num: undefined,
        king_camp_id: undefined,
        nobility_level: undefined,
        qq:'',
        wx:'',
        remark:'',
        camp_account:''
      }
      this.rules = {
        skin_num: [
          {required: true, message: '请输入拥有皮肤数量', trigger: 'blur'}
        ],
        hero_num: [
          {required: true, message: '请输入拥有英雄数量', trigger: 'blur'}
        ],
        qq: [
          {required: true, message: '请输入QQ号', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{4,9}$/, message: 'QQ账号格式错误'}
        ],
        wx: [
          {required: true, message: '请输入微信号', trigger: 'blur'}
        ],
        // qq: [
        //   {required: false, validator: this.validatePass, trigger: 'blur'}
        // ],
        // wx: [
        //   {required: false, validator: this.validatePass1, trigger: 'blur'}
        // ],
        king_camp_id: [
          {required: true, message: '请输入营地账号', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{6,11}$/, message: '营地账号格式错误'}
        ],
        cdata: [
          {required: true, validator: this.validatecdata, trigger: 'change'}
        ],
        armsData: [
          {required: true, validator: this.validatearmsData, trigger: 'change'}
        ],
        nobility_level: [
          {required: true, message: '请输入贵族等级', trigger: 'blur'}
        ],
        camp_account: [
          {required: true, message: '请输入助手社区ID', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{4,11}$/, message: '助手社区ID格式错误'}
        ],
      };

      apiProductCategory({
        game_id: game_id,
        type: 'assess'
      }).then(res => {
        res.data.forEach(item => {
          if (this.gameItem.game_alias === 'yuanshen' && item.cat_id === 2 || this.gameItem.game_alias === 'bhxqtd' && item.cat_id === 2) {
            this.roleList = item.entries
          }
          if (this.gameItem.game_alias === 'yuanshen' && item.cat_id === 3 || this.gameItem.game_alias === 'bhxqtd' && item.cat_id === 3) {
            this.weaponList = item.entries
          }
          if (item.is_gaoji === 1 && this.gameItem.game_alias !== 'bhxqtd') {
            if (item.haveAttr) {
              this.filterOptions.push(item)
            } else {
              this.filterGrouping.push(item)
            }
          } else {
            if((this.gameItem.game_alias !== 'bhxqtd'&&item.unique_id != 'ajg' && item.unique_id != 'rzhs') || (this.gameItem.game_alias === 'bhxqtd'&&(item.cat_id!=2&&item.cat_id!=3))){
              this.filterData.push(item)

              this.$set(this.infoForm,item.unique_id,null)
              this.$set(this.rules, item.unique_id, [{required: true, message: '请选择'+item.cat_name.slice(1), trigger: 'change'}])
            }
          }
          this.formKeyList[item.unique_id] = item.cat_id
        })
        if(this.active == 1)
        this.$nextTick(()=>{
          this.$refs['infoForm'].clearValidate();
        })
      })
    },
    // 步骤1选取游戏
    c1Next(item) {
      this.$sensorsTrack.ValuationGameSelect(item.label,item.value)
      if (this.$store.state.loginStatus) {
        // this.infoForm = {}
        // console.log(storage.getItem(item.game_alias+item.value))
        if(storage.getItem(item.game_alias+item.value)){
          this.UnpublishedDialogVisible = true
        }else{
          this.active = 1;
          this.$nextTick(()=>{
            this.$refs['infoForm'].resetFields();
          })

          storage.removeItem(item.game_alias+item.value)
        }
        this.getProductCategory(item.value)
        this.gameItem = {...item}
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.path,
            game_name: this.item.label,
            game_id: this.item.value,
            id: this.id,
          },
        })
      }
    },

    /**
     * 步骤二 游戏账号 发布商品
     * @param formName 表单名称
     */
    c2Next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$sensorsTrack.AddValuationInformation(this.gameItem.label,this.gameItem.value,this.infoForm.remark)
          this.EstimateSubmission = true
        } else {
          scrollIntoView()
          // setTimeout(() => {
          //   var isError = document.getElementsByClassName("is-error");
          //   if (isError[0].querySelector('input')) {
          //     isError[0].querySelector('input').focus();
          //   } else if (isError[0].querySelector('textarea')) {
          //     isError[0].querySelector('textarea').focus();
          //   }
          // }, 100);
          // console.log('error submit!!');
          return false;
        }
      });
    },

    /**
     * 步骤二 重选
     */
    resBtn() {
      this.active = 0
      this.$refs['infoForm'].resetFields()
    },
    // 估价商品提交
    ESsubmit(){
      if (!this.addFlag) {
        return
      }
      this.addFlag = false
      this.EstimateSubmission = false
      let prams = {};
      for(let i in this.infoForm){
        if(this.formKeyList[i]){
          prams[this.formKeyList[i]] = this.infoForm[i]
        }else if(['childList'].indexOf(i)!=-1){

        }else if(['qq','remark','hero_num','skin_num','nobility_level','honor_crystal','cdata','wx','armsData','big_nation','camp_account','small_nation'].indexOf(i)==-1){
          prams[i] = this.infoForm[i]
        }
      }
      let pathList = []
      let filePath = this.filePath || []
      if (filePath.length > 0) {
        this.filePath.forEach((item, index) => {
          pathList.push(item.path)
        })
      }
      let pathListA = []
      let filePathA = this.filePathA || []
      if (filePathA.length > 0) {
        this.filePathA.forEach((item, index) => {
          pathListA.push(item.path)
        })
      }
      apiValuation({
        game_id: this.gameItem.value,
        qq: this.infoForm.qq,
        wx: this.infoForm.wx,
        category:prams,
        description:this.infoForm.remark,
        cdata: JSON.stringify(this.infoForm.cdata) || JSON.stringify(pathList),
        arms_data: JSON.stringify(this.infoForm.armsData) || JSON.stringify(pathListA),
        camp_account: this.gameItem.value === 25?this.infoForm.camp_account:this.infoForm.king_camp_id,
        skin_num: this.infoForm.skin_num,
        hero_num: this.infoForm.hero_num,
        small_nation:this.infoForm.small_nation || 0,
        big_nation:this.infoForm.big_nation || 0,
        honor_crystal:this.infoForm.honor_crystal || 0,
        nobility_level: this.infoForm.nobility_level,
        role: this.role,
        arms: this.arms,
      }).then(res => {
        this.valuationInfo = res.data
        this.$sensorsTrack.SubmitValuationSuccess(this.gameItem.label,this.gameItem.value,this.infoForm.remark)
        this.sell_customer = res.data.sell_customer
        storage.removeItem(this.gameItem.game_alias+this.gameItem.value)
        if (this.active++ >= 2) this.active = 0;

        if(res.data.auto_valuation==1){
          this.active =1
          this.valuationDialog=true

        }else{
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.$message({
            message: "发布成功",
            center: true,
            type: "success"
          })
        }

      }).catch(err => {
        this.$message({
          message: err.msg,
          center: true,
          type: "error"
        })
      }).finally(f=>{
        this.addFlag = true
      })
    },
    /**
     * 原神角色选择
     * @param list
     */
    roleChange(list){
      this.role = list
    },
    /**
     * 原神武器选择
     * @param list
     */
    armsChange(list){
      this.arms = list
    },
  },
  mounted() {
    this.getGameList('')
  },
  beforeDestroy() {
    clearTimeout(this.gameListLoadingTimer)
  },
  watch: {},
  computed: {
  },
  beforeRouteEnter(to,from,next){
    next((vm) => {
      vm.$sensorsTrack.AccValuationView(from.name)
    })
  }
}
</script>

<!-- 弹框 -->
<style lang="less">
.Unpublished.el-dialog {
  border-radius: 4px;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: 0 18px 46px rgba(26, 29, 36, 0.16);
  overflow: visible;

  .el-dialog__header {
    display: none;
    padding: 0;
  }
}

.Unpublished {
  background: var(--bg-card, #FFFFFF);
  border-radius: 4px;
  position: relative;
  overflow: visible;

  .el-dialog__body {
    padding: 26px 30px 26px;
    position: relative;

    #UPS_main {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      &::before {
        content: '';
        width: 44px;
        height: 44px;
        margin: 0 0 14px;
        border-radius: 4px;
        background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
        box-shadow: 0 12px 26px rgba(26, 29, 36, 0.22);
      }

      &::after {
        content: '';
        position: absolute;
        top: 14px;
        left: 50%;
        width: 18px;
        height: 10px;
        border-left: 3px solid #FFFFFF;
        border-bottom: 3px solid #FFFFFF;
        transform: translateX(-50%) rotate(-45deg);
        border-radius: 1px;
      }

      .UPS_info {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-height: 60px;
        margin: 0 0 18px;

        .UPS_name {
          align-self: center;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 600;
          color: var(--text-main, #111827);
          line-height: 28px;
          margin: 0 0 6px;
          text-align: center;
        }

        .UPS_text {
          width: 100%;
          min-height: 22px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 22px;
          text-align: center;
        }
      }

      .UPS_btn {
        display: flex;
        justify-content: space-between;

        >button{
          display: inline-block;
          width: 139px;
          height: 38px;
          border-radius: 4px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          text-align: center;
          line-height: 38px;
          cursor: pointer;
          transition: box-shadow 0.2s ease, transform 0.2s ease, opacity 0.2s ease, color 0.2s ease, border-color 0.2s ease, background 0.2s ease;

          &:hover {
            transform: translateY(-1px);
          }

          &:active {
            opacity: 0.9;
            transform: translateY(0);
          }
        }

        .UPS_reset{
          border: 1px solid var(--border-soft, #E8E4DE);
          background-color: var(--bg-card, #FFFFFF);
          color: var(--text-secondary, #5A5F6B);
          margin-right: 14px;

          &:hover {
            border-color: rgba(26, 29, 36, 0.28);
            background: var(--brand-blue-light, #F0EDE8);
            color: var(--brand-blue, #1A1D24);
            box-shadow: 0 8px 18px rgba(26, 29, 36, 0.12);
          }
        }

        .UPS_continue{
          border: none;
          background: var(--primary, #FF5A1F);
          color: #FFFFFF;

          &:hover {
            background: var(--primary-hover, #E84A12);
            box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
          }
        }

        .ESconfirm{
          width: 233px;
          height: 40px;
          line-height: 40px;
        }
      }
    }

    .UPS_close {
      position: absolute;
      bottom: -46px;
      left: 50%;
      cursor: pointer;
      width: 30px;
      height: 30px;
      transform: translateX(-50%);
    }
  }
}
.camp_accountDialog{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto ;
  max-height: 660px;
  background:transparent;
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
  #camp_accountDialog,#ys_accountDialog{
    width: 1157px;
    .content{
      width: 100%;
      object-fit: contain;
    }
    .btn{
      position: absolute;
      top: 15px;
      right: -80px;
      cursor: pointer;
    }
  }
}
</style>

<style lang='less' scoped>
/deep/ .el-select__caret {
  font-size: 18px !important;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary, #FF5A1F);
}

/deep/ .el-input__inner:focus,/deep/ .el-textarea__inner:focus{
  border-color: var(--primary, #FF5A1F);
}

/deep/ .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-select-dropdown__item.selected {
  color: var(--brand-blue, #1A1D24) !important;
  font-weight: normal !important;
}

/deep/ .el-pagination {
  font-weight: 400;
  font-family: PingFangSC-Light, PingFang SC;
}

/deep/ .el-select-dropdown el-popper {
  min-width: 224px;
  left: 146px;
}

/deep/ .el-select-dropdown__item /deep/ .selected {
  color: var(--brand-blue, #1A1D24) !important;
}
/deep/.el-select-dropdown__item.hover{
  background-color: var(--brand-blue-light, #F0EDE8);
}

/deep/ *.popper__arrow {
  left: 345px !important;
}

/deep/ .el-upload--picture-card:hover, /deep/ .el-upload--picture-card:focus,/deep/ .el-input {
  border-color: var(--primary, #FF5A1F);

  i {
    color: var(--primary, #FF5A1F);
  }
}
/deep/ .el-input{
  width: 220px;
}
.infoForm_image {
  width: 100%;
  object-fit: cover;
}
/deep/ .el-input-number{
  width: auto;
}
/deep/ .el-input-number .el-input__inner{
  text-align: left;
}

.account_sell {
  width: 1200px;
  margin: 0 auto;

  .title {
    height: 60px;
    display: flex;
    align-items: center;
    margin-left: 5px;

    a {
      .Breadcrumb {
        font-size: 12px;
      }
    }

    a:first-of-type {
      font-size: 16px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 300;
      color: var(--text-muted, #9AA0AC);
    }

    a:last-of-type {
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--brand-blue, #1A1D24);
    }
  }

  .list {
    width: 1110px;
    //height: 600px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 0 0 4px 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    padding: 30px 40px 74px 50px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .steps {
      width: 450px;

      /deep/ .el-step__line-inner {
        display: none !important;
      }

      /deep/ .el-step__line {
        left: 0%;
        right: 0%;
        height: 2px;
      }

      /deep/ .is-finish > .el-step__line {
        background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
        top: 10px;
        height: 4px;
      }

      /deep/ .is-process > .el-step__line {
        background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
        top: 10px;
        height: 4px;
      }

      /deep/ .is-wait > .el-step__line {
        display: block;
      }

      /deep/ .is-process > .el-step__line {
        display: block;
      }

      /deep/ .el-step__icon {
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: none;
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        background: var(--bg-card-soft, #F0EDE8);
      }

      /deep/ .is-finish > .el-step__icon {
        background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
        color: #FFFFFF;
      }

      /deep/ .is-process > .el-step__icon {
        background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
        color: #FFFFFF;
      }

      /deep/ .el-step__title {
        margin: 10px 0 0 0;
        line-height: 22px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }
    }

    .content1 {
      width: 1110px;
      //height: 498px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .c1Select {
        display: flex;
        flex-direction: row;
        justify-content: center;

        .content1_item {
          //width: 175px;
          flex: 1;
          height: 398px;
          margin: 0 10px 0 0;
          max-width: 190px;

          .c1-item-title {
            height: 50px;
            background: var(--brand-blue-light, #F0EDE8);
            border: 1px solid var(--border-soft, #E8E4DE);
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: var(--text-main, #111827);
            line-height: 50px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap
          }

          .c1-item-serach {
            //width: 133px;
            width: calc(~"100% - 40px");;
            margin: 4px 0;
            height: 34px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid var(--border-soft, #E8E4DE);
            padding: 0 20px;
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: var(--text-main, #111827);
          }

          .c1-item-serach::-webkit-input-placeholder {
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #BFBFBF;
          }

          .c1-item-select {
            overflow: auto;
            height: 300px;
            background: #FFFFFF;
            border: 1px solid var(--border-soft, #E8E4DE);

            .c1-select-opitons {
              //width: 175px;
              height: 50px;
              font-size: 16px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 300;
              color: var(--text-secondary, #5A5F6B);
              line-height: 50px;
              text-align: center;
              cursor: pointer;
              overflow: hidden;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;

              #smqk {
                display: flex;
              }
            }

            .opitonsSelect {
              background: var(--brand-blue-light, #F0EDE8);
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
              font-family: PingFangSC-Regular, PingFang SC;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              #smqk {
                display: flex;
              }
            }

            .c1-select-opitons:hover {
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.12);
              background: var(--brand-blue-light, #F0EDE8);
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
              font-family: PingFangSC-Regular, PingFang SC;
            }
          }

          .c1-item-select::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
            background: rgba(0, 0, 0, 0.1);
          }

          .c1-item-select::-webkit-scrollbar {
            width: 6px;
            height: 5px;
          }

          .c1-item-select::-webkit-scrollbar-thumb {
            border-radius: 4px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
            background: rgba(0, 0, 0, 0.3);
          }
        }

        .is_gaoji {
          margin: 0;
        }
      }

      .content1_body {
        margin: 32px 0 0;
        height: 480px;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        display: flex;
        flex-direction: row;


        .tree {
          width: 150px;
          background: var(--bg-section, #F7F5F2);
          padding: 30px 0 0;
          border-right: 1px solid var(--border-soft, #E8E4DE);

          .treeBtn {

            width: 150px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            text-align: center;
            cursor: pointer;
          }

          .treeBtnSelect {
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            display: flex;
            flex-direction: row;
            align-items: center;
            background: var(--brand-blue-light, #F0EDE8);
            color: var(--brand-blue, #1A1D24);

            span {
              display: inline-block;
              width: 7px;
              height: 20px;
              background: var(--brand-blue, #1A1D24);
              border-radius: 0 3px 3px 0;
              margin: 0 36px 0 0;
            }
          }
        }

        .content1_content {
          width: 740px;
          padding: 20px 0 50px 25px;
          display: flex;
          flex-direction: column;
          position: relative;

          .game_list_panel {
            width: 100%;
            height: 390px;
            position: relative;

            .game_loading {
              position: absolute;
              inset: 0;
              z-index: 2;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              background: rgba(248, 250, 255, 0.56);

              i {
                font-size: 42px;
                color: rgba(26, 29, 36, 0.56);
              }
            }
          }

          .C1C_cardList {
            display: grid;
            grid-template-columns: repeat(7, 80px);
            justify-content: space-between;
            align-content: start;
            row-gap: 8px;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 4px 12px 0 0;
            height: 390px;
            scrollbar-width: thin;
            scrollbar-color: rgba(26, 29, 36, 0.34) var(--bg-card-soft, #F0EDE8);

            &::-webkit-scrollbar{
              width: 6px;
              height: 6px;
            }
            &::-webkit-scrollbar-thumb {
              border-radius: 4px;
              background: rgba(26, 29, 36, 0.34);
              border: 2px solid transparent;
              background-clip: content-box;

              &:hover {
                background: rgba(26, 29, 36, 0.58);
                background-clip: content-box;
              }
            }
            &::-webkit-scrollbar-track {
              border-radius: 4px;
              background: var(--bg-card-soft, #F0EDE8);
            }
            .game_list{
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 80px;
              height: 98px;
              text-align: center;
              color: var(--text-secondary, #5A5F6B);
              cursor: pointer;
              border: 1px solid transparent;
              border-radius: 4px;
              box-sizing: border-box;
              padding: 5px 7px 4px;
              transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
              margin: 0;
              img{
                width: 56px;
                height: 56px;
                border-radius: 4px;
                display: inline-block;
                margin-bottom: 6px;
                object-fit: cover;
                box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
              }
              .game_name {
                width: 100%;
                line-height: 19px;
                font-size: 13px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: inherit;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &:hover {
                background: var(--brand-blue-light, #F0EDE8);
                border-color: rgba(26, 29, 36, 0.22);
                box-shadow: 0 10px 22px rgba(26, 29, 36, 0.14);
                color: var(--brand-blue, #1A1D24);
                transform: translateY(-3px);

                .game_name {
                  font-weight: 500;
                }
              }
            }
          }

          .empty_game {
            width: 100%;
            height: 390px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 0 4px;
            color: var(--text-secondary, #5A5F6B);

            .empty_icon {
              width: 56px;
              height: 56px;
              margin: 0 0 14px;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: var(--bg-card-soft, #F0EDE8);
              border: 1px solid var(--border-soft, #E8E4DE);
              color: var(--text-muted, #9AA0AC);
              font-size: 28px;
            }

            .empty_title {
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--text-main, #111827);
              line-height: 26px;
              margin: 0 0 6px;
            }

            .empty_text {
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);
              line-height: 22px;
            }
          }

          .c1_tip{
            width: 270px;
            height: 37px;
            background: var(--warning-soft, #FFFBEB);
            position: absolute;
            bottom: 10px;
            border-radius: 4px;
            font-size: 14px;
            color: var(--warning, #F59E0B);
            line-height: 37px;
            img{
              width: 14px;
              // height: 19px;
              vertical-align: middle;
              display: inline-block;
              margin: 0 5px 0 20px;
            }
          }
        }
      }
    }

    .content2 {
      width: 1090px;
      background: var(--bg-card, #FFFFFF);
      .c2Title {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #111827);
        line-height: 28px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 0 32px 0;

        img {
          margin: 0 20px 0 0;
        }
        .tip{
          margin: 0 0 0 150px;
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          display: flex;
          align-items: baseline;
          padding: 4px 10px 4px 29px;
          background: var(--brand-blue-light, #F0EDE8);
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid rgba(26, 29, 36, 0.22);
          img{
            width: 39px;
            height: 8px;
          }
        }
      }
      /deep/ .el-select-dropdown__item.selected{
        color: var(--brand-blue, #1A1D24) !important;
      }
      .c2CurrentSelection{
        padding-bottom: 34px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        margin-bottom: 50px;
        .c2SelectedContent {
          margin-left: 30px;
          color: var(--text-main, #111827);
          img {
            width: 60px;
            height: 60px;
            border-radius: 4px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 17px;
            object-fit: cover;
            box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
          }
        }
        .resBtn {
          display: inline-block;
          margin: 0 0 0 27px;
          width: 100px;
          height: 30px;
          background: var(--primary, #FF7A1A);
          border-radius: 4px;
          line-height: 30px;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #FFFFFF;
          text-align: center;
          cursor: pointer;
          box-shadow: 0 8px 16px rgba(249, 115, 22, 0.16);
          transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

          &:hover {
            background: var(--primary-hover, #F97316);
            box-shadow: 0 10px 18px rgba(249, 115, 22, 0.24);
            transform: translateY(-1px);
          }
        }
      }
      .c2ProductInfo {
        padding-bottom: 34px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        margin-bottom: 50px;
        .how_king{
          color: var(--danger, #EF4444);
          font-size: 14px;
          i{
            display: inline-block;
            height: 20px;
            margin: 0 2px 0 10px;
          }
        }
        .curr_choose{
          display: block;
          font-size: 16px;
          color: var(--text-secondary, #5A5F6B);
          i{
            font-style: normal;
            font-size: 14px;
            color: var(--text-secondary, #5A5F6B);
          }
        }
        .melee_weapon{
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          width: 890px;
          margin:0 auto 20px;
          background: var(--bg-section, #F7F5F2);
          .mw_title{
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid var(--border-soft, #E8E4DE);
            color: var(--text-main, #111827);
            font-size: 18px;
            font-weight: 600;
            text-indent: 30px;
            margin-bottom: 21px;
          }
        }
      }
      .tymyd_fuck{
        border-bottom: none;
        .fuck_tymyd_tip{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          padding: 0 20px;
          line-height: 30px;
        }
        .fuck_tymyd_btn{
          width: 171px;
          height: 40px;
          line-height: 40px;
          background: var(--primary, #FF7A1A);
          border-radius: 4px;
          margin: 85px auto 0;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: CENTER;
          color: #FFFFFF;
          cursor: pointer;
          box-shadow: 0 10px 18px rgba(249, 115, 22, 0.18);
          transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

          &:hover {
            background: var(--primary-hover, #F97316);
            box-shadow: 0 12px 22px rgba(249, 115, 22, 0.26);
            transform: translateY(-1px);
          }
        }
      }
      .c2RemarkConnect{

        .remark_st{
          width: 714px;
          height: 200px;
          /deep/.el-textarea__inner{
              resize: none;
              width: 100%;
              height: 100%;
          }
        }
      }
      .c2SubmitBtn{
        width: 300px;
        height: 50px;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        text-align: center;
        margin: 0 auto;
        cursor: pointer;
        box-shadow: 0 12px 22px rgba(255, 90, 31, 0.22);
        transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        &:hover {
          background: var(--primary-hover, #E84A12);
          box-shadow: 0 14px 26px rgba(255, 90, 31, 0.3);
          transform: translateY(-1px);
        }

        div{
          font-size: 18px;
          line-height: 50px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #FFFFFF;
        }
      }
    }

    .content3 {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .c3Img {
        width: 1110px;
        padding: 59px 0 56px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        img {
          width: 197px;
          height: 130px;
          object-fit: cover;
          margin: 0 26px 0 0;
        }

        .c3Img_text {
          .c3_success {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--text-main, #111827);
            margin: 0 6px 6px 19px;
          }

          .c3_ground {
            width: 355px;
            background: var(--bg-card, #FFFFFF);
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            overflow: hidden;

            .c3G_id {
              padding: 6px 0 7px 19px;
              background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: #ffffff;
              span{
                color: #FFFFFF;
              }
            }

            .c3G_text {
              padding: 8px 0 10px 19px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Light;
              font-weight: 300;
              color: var(--text-secondary, #5A5F6B);

              span {
                font-weight: 500;
                color: var(--primary, #FF7A1A);
              }
            }
          }


        }

      }

      .c3Btn {
        width: 298px;
        height: 48px;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        font-size: 18px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #111827);
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        &:hover {
          border-color: rgba(26, 29, 36, 0.28);
          background: var(--brand-blue-light, #F0EDE8);
          color: var(--brand-blue, #1A1D24);
          transform: translateY(-1px);
        }
      }

      .c3CusSerBtn {
        margin: 0 0 10px 0;
        background: var(--primary, #FF7A1A);
        border: 1px solid var(--primary, #FF7A1A);
        color: #FFFFFF;
        box-shadow: 0 12px 22px rgba(249, 115, 22, 0.2);

        &:hover {
          background: var(--primary-hover, #F97316);
          border-color: var(--primary-hover, #F97316);
          color: #FFFFFF;
          box-shadow: 0 14px 26px rgba(249, 115, 22, 0.28);
        }
      }

      .c3_tip {
        margin: 0 0 8px 0;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
      }
    }
  }
  .advertising{
    position: fixed;
    top: calc(70% - 400px);
    left: calc(100% - 1200px - 263px - ((100% - 1200px) / 2));
    width: 253px;
    z-index: 999;
    img{
      width: 100%;
    }
  }


}
</style>
